import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TrendResponse} from '@npck/af-frontend-api';
import {Spinner} from '@npck/libs/commons';
import {DESCRIPTION_MAX_LENGTH, DESCRIPTION_MIN_LENGTH} from '../../../../../domain/constants';

@Component({
    selector: 'af-trend-information-step',
    templateUrl: './trend-information-step.component.html',
    styleUrl: './trend-information-step.component.scss',
    standalone: false
})
export class TrendInformationStepComponent implements OnInit {
    @Input() form: FormGroup<TrendInformationForm>;
    @Input() trend: TrendResponse;
    @Output() nextStep = new EventEmitter<void>;
    @Output() typeChangeListener = new EventEmitter<string>;
    @Output() cancel = new EventEmitter<void>;
    Spinner = Spinner;
    DESCRIPTION_MAX_LENGTH = DESCRIPTION_MAX_LENGTH;
    DESCRIPTION_MIN_LENGTH = DESCRIPTION_MIN_LENGTH;
    private destroyRef = inject(DestroyRef);

    submit(): void {
        this.form.markAllAsTouched();
        if (this.form.invalid) {
            return;
        }
        this.nextStep.emit();
    }

    ngOnInit(): void {
        this.buildForm(this.trend);
    }

    private buildForm(trend?: TrendResponse): void {
        this.form.addControl('description', new FormControl(trend.description, [Validators.required]));
        this.form.addControl('conclusion', new FormControl(trend?.conclusion, [Validators.required]));
        this.form.addControl('keywords', new FormControl(trend?.keywords, [Validators.required]));
    }
}

export interface TrendInformationForm {
    description?: FormControl<string>;
    conclusion?: FormControl<string>;
    keywords?: FormControl<string>;
}
